var map = {
	"./banner/pos1.png": 4948,
	"./banner/pos2.png": 79439,
	"./banner/pos3.png": 40422,
	"./banner/pos4.png": 73465,
	"./banner/pos5.png": 67216,
	"./mobile/banner/pos1.png": 3741,
	"./mobile/banner/pos2.png": 22534,
	"./mobile/banner/pos3.png": 4079,
	"./mobile/banner/pos4.png": 18704,
	"./mobile/banner/pos5.png": 24953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52950;